import { BodyText } from '@calendly/ui/components/typography'
import { colorTextActionContrast } from '@calendly/ui/theme'
import { useContext, useEffect, useRef } from 'react'

import { MenuKeyboardContext } from '../menu_keyboard_context'
import { Button, Description } from './styles'

// role is needed for accessibility
export const Option = ({ name, description, example, kind, poolingType, onClick, ...props }) => {
  const buttonRef = useRef(null)
  const { registerMenuItem } = useContext(MenuKeyboardContext)

  useEffect(() => registerMenuItem(buttonRef.current), [registerMenuItem])

  return (
    <Button ref={buttonRef} role="menuitem" onClick={() => onClick(kind, poolingType)} {...props}>
      {typeof name === 'string' ? <BodyText color={colorTextActionContrast} weight="bold">{name}</BodyText> : name}
      {description && <Description>{description}</Description>}
      <BodyText color="muted" size="medium">{example}</BodyText>
    </Button>
  )
}
